<h4 class="text-center">
    Buch-Aktivierung erfolgt über Digi4School
</h4>
<p class="text-center">
    Die Freischaltung dieses Buchs erfolgt über Digi4School.<br/>
    Bitte auf Digi4School anmelden, Digi4School-Code aktivieren.<br/>
    Anschließend erfolgt die Weiterleitung zum Blätterbuch auf digi.schule.
</p>

<p class="text-center">
    <a class="btn btn-semibold btn-round btn-digi4school" href="https://digi4school.at/" rel="nofollow">zu
        Digi4School</a>
</p>